import { render, staticRenderFns } from "./MiniVanGrupo.vue?vue&type=template&id=768835d3&"
import script from "./MiniVanGrupo.vue?vue&type=script&lang=js&"
export * from "./MiniVanGrupo.vue?vue&type=script&lang=js&"
import style0 from "./MiniVanGrupo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports